// <editor-fold desc="Action Types">

/**
 * Action types
 */
export enum ActionTypes {
  /**
   * Store
   */
  GetCopyrightsSuccess = '[STORE | SHARED | CONSTANT] Get Copyrights Success',
  GetCopyrights = '[STORE | AUTHOR | CONSTANT] Get Copyrights',
  GetModalitiesSuccess = '[STORE | SHARED | CONSTANT] Get Modalities Success',
  GetModalities = '[STORE | AUTHOR | CONSTANT] Get Modalities',
  GetStainsSuccess = '[STORE | SHARED | CONSTANT] Get Stains Success',
  GetStains = '[STORE | AUTHOR | CONSTANT] Get Stains',
  /**
   * Request
   */
  GetCopyrightsRequest = '[REQUEST | AUTHOR | CONSTANT] Get Copyrights Request',
  GetCopyrightRequest = '[REQUEST | AUTHOR | CONSTANT] Get Copyright Request',
  GetModalitiesRequest = '[REQUEST | AUTHOR | CONSTANT] Get Modalities Request',
  GetModalityRequest = '[REQUEST | AUTHOR | CONSTANT] Get Modality Request',
  GetStainsRequest = '[REQUEST | AUTHOR | CONSTANT] Get Stains Request',
  GetStainRequest = '[REQUEST | AUTHOR | CONSTANT] Get Stain Request',
}

// </editor-fold>

// <editor-fold desc="Models">

// </editor-fold>

// <editor-fold desc="Store">

//<editor-fold desc="Copyrights">
/**
 * Get Copyrights Success
 */
export class GetCopyrightsSuccess {
  public static readonly type = ActionTypes.GetCopyrightsSuccess;
}

/**
 * Get Copyrights
 */
export class GetCopyrights {
  public static readonly type = ActionTypes.GetCopyrights;
}
//</editor-fold>

//<editor-fold desc="Modalities">
/**
 * Get Modalities Success
 */
export class GetModalitiesSuccess {
  public static readonly type = ActionTypes.GetModalitiesSuccess;
}

/**
 * Get Modalities
 */
export class GetModalities {
  public static readonly type = ActionTypes.GetModalities;
}
//</editor-fold>

//<editor-fold desc="Stains">
/**
 * Get Stains Success
 */
export class GetStainsSuccess {
  public static readonly type = ActionTypes.GetStainsSuccess;
}

/**
 * Get Stains
 */
export class GetStains {
  public static readonly type = ActionTypes.GetStains;
}
//</editor-fold>

// </editor-fold>

// <editor-fold desc="Request">

//<editor-fold desc="Copyrights">
/**
 * Get Copyrights Request
 */
export class GetCopyrightsRequest {
  public static readonly type = ActionTypes.GetCopyrightsRequest;
}

/**
 * Get Copyright
 */
export class GetCopyrightRequest {
  public static readonly type = ActionTypes.GetCopyrightRequest;

  public constructor(public id: string) {
  }
}
//</editor-fold>

//<editor-fold desc="Modalities">
/**
 * Get Modalities Request
 */
export class GetModalitiesRequest {
  public static readonly type = ActionTypes.GetModalitiesRequest;
}

/**
 * Get Modality
 */
export class GetModalityRequest {
  public static readonly type = ActionTypes.GetModalityRequest;

  public constructor(public id: string) {
  }
}
//</editor-fold>

//<editor-fold desc="Stains">
/**
 * Get Stains Request
 */
export class GetStainsRequest {
  public static readonly type = ActionTypes.GetStainsRequest;
}

/**
 * Get Stain
 */
export class GetStainRequest {
  public static readonly type = ActionTypes.GetStainRequest;

  public constructor(public id: string) {
  }
}
//</editor-fold>

// </editor-fold>
